import PropTypes from "prop-types";
import React, { memo } from "react";
import Icon from "../Icon";

function CheckList({ data, itemMargin, className, fontClass, customText }) {
  return (
    <ul className={`p-0 list-none max-w-full ${className}`}>
      {data.map(({ id, text, subList }) => (
        <>
          <li className={`${itemMargin} last:mb-0 flex`} key={id}>
            <span className="w-5 h-5 flex justify-center items-center rounded-full mt-[2px] mr-2 bg-cf-primary flex-none">
              <Icon name="tick" width="9.21px" height="6.29px" fill="#fff" />
            </span>
            <h3 className={`font-body !m-0 ${fontClass} ${customText}`}>
              {text}
            </h3>
          </li>

          {subList?.length > 0 && (
            <ul className="pl-10 mb-0 md:mt-[28px] list-disc">
              {subList.map(({ id: subId, text: subText }) => (
                <li className="mb-6 last:mb-0" key={subId}>
                  <h3 className="font-body leading-6 text-[14px] font-normal ">
                    {subText}
                  </h3>
                </li>
              ))}
            </ul>
          )}
        </>
      ))}
    </ul>
  );
}

CheckList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      subList: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
        }),
      ),
    }),
  ),
  itemMargin: PropTypes.string,
  fontClass: PropTypes.string,
  className: PropTypes.string,
  customText: PropTypes.string,
};

CheckList.defaultProps = {
  data: [],
  itemMargin: "mb-4",
  fontClass: "text-[14px] md:text-[15px]  md:leading-6",
  className: "mb-[32px]",
  customText: "font-semibold",
};

export default memo(CheckList);
